const CloseButton = ({ onClick, disabled = false }) => {
  return (
    <button
    onClick={onClick}
    disabled={disabled}  
    type="button" 
    className="bg-white w-11 rounded-full p-2 shadow-lg hover:bg-blue-100 hover:border-blue-500 border-2 disabled:opacity-50 disabled:cursor-not-allowed"
    >
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
    </svg>
    </button>
  );
};

export default CloseButton;